import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  chartContainer: {
    position: "relative",
    display: "flex",
    width: "100%",
    height: "20px",
    backgroundColor: theme.custom.color.gainsboro,
    borderTopRightRadius: "10px",
    borderBottomRightRadius: "10px",
  },
  chartItem: {
    position: "absolute",
    height: "100%",
    borderTopRightRadius: "10px",
    borderBottomRightRadius: "10px",
    left: 0,
    transition: "all 0.3s ease",
  },
  chartItemLabel: {
    position: "absolute",
    left: "10px",
    alignItems: "center",
    top: "2px",
    margin: "auto 0",
    zIndex: 10,
    textTransform: "uppercase",
    lineHeight: "16px",
    fontSize: "14px",
    fontWeight: 700,
    color: theme.custom.color.white,
  },
}));

// Export the useStyles hook
export default useStyles;
